<template>
  <a-layout-content  id="about_us" class="all-c about-us-content">
    <div>
      <div class="text-section en" v-show="isEnglish">
        <h2 class="title">{{ $t('atCharlotteAndYou') }}</h2>
        <h2 class="sub-title">{{ $t('weWorkClosely') }}</h2>
        <div class="img-box mobile">
          <img src="../../public/2.png" alt="about us" />
        </div>
        <p>{{ $t('ourMission') }}</p>
        <p>{{ $t('ourMission2') }}</p>
        <p>{{ $t('ourMission3') }}</p>
      </div>
      <div class="text-section cn" v-show="!isEnglish">
        <h2 class="title">{{ $t('atCharlotteAndYouCn') }}</h2>
        <h2 class="sub-title">{{ $t('weWorkCloselyCn') }}</h2>
        <p>{{ $t('ourMissionCn') }}</p>
      </div>
      <div class="img-box">
        <img src="../../public/2.png" alt="about us" />
      </div>
    </div>
  </a-layout-content>
</template>

<script>
export default {
  data() {
    return {
      isEnglish: true
    };
  },
  computed: {
    currentLang() {
      return this.$i18n.locale;
    }
  },
  watch: {
    currentLang(newLang) {
      this.isEnglish = newLang === 'en';
    }
  }
};
</script>

<style scoped lang="less">
@mainBg: #f8f5f0;
@mainBg2: #f8f5f1;
@mainColor1: #de94a4;
@mainColor2: #eebac0;
@mainColor3: #A98578;
@mainColor4: #F6DEC7;
@mainFont: "MontserratMedium", sans-serif;
@mainFontSub: "MontserratLight", sans-serif;
@mainFontCn: 'Huangchan', sans-serif;
.about-us-content {
  height: calc(100vh - 110px);
  font-size: 1.4vw;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: @mainFont;
  > div {
    width: 85vw;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1vw;
    .text-section {
      flex: 1;
  
      .title {
        margin: 0;
        color: @mainColor1;
        font-weight: 600;
        font-size: 1.5em;
      }
  
      .sub-title {
        margin: 0;
        color: @mainColor3;
        font-size: 1.5em;
        margin-bottom: 0.5em;
        font-weight: 600;
      }
  
      p {
        font-size: 1.2em;
        margin-bottom: 0.5em;
        color: rgba(0,0,0, 0.8)
      }
    }
    .img-box {
      width: 50%;
      img {
        width: 100%;
      }
      &.mobile {
        display: none;
      }
    }
  }
  @media screen and (max-width: 768px) {
    > div {
      flex-direction: column;
      font-size: 1vw;
      padding: 2em;
      .text-section {
        margin-bottom: 2em;
        .title {
          font-size: 3.5em;
        }
        .sub-title {
          font-size: 3.5em;
        }
        p {
          font-size: 3.3em;
        }
      }
      .img-box {
        display: none;
        &.mobile {
          display: block;
          width: 100%;
          /*
            background-color: @mainColor4;
          */
          img {
            width: 75%;
            margin: 3vw auto;
          }
        }
      }
    }
  }
}
</style>